import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { getImageUrl } from '../utils/api';
import { useSEO } from '../utils/seo';
import './ArtistLinksPage.css';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const getFileUrl = (url) => {
  if (!url) return '';
  return getImageUrl(url) || '';
};

export const ICON_MAP = {
  spotify: (
    <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22"><path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z"/></svg>
  ),
  apple: (
    <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22"><path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/></svg>
  ),
  soundcloud: (
    <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22"><path d="M1.175 12.225c-.051 0-.094.046-.101.1l-.233 2.154.233 2.105c.007.058.05.098.101.098.05 0 .09-.04.099-.098l.255-2.105-.27-2.154c-.01-.057-.05-.1-.1-.1m-.899.828c-.06 0-.091.037-.104.094L0 14.479l.172 1.282c.013.06.045.094.104.094.057 0 .09-.037.104-.09l.2-1.286-.2-1.332c-.014-.057-.047-.094-.104-.094m1.8-1.137c-.065 0-.11.05-.116.112l-.212 2.451.212 2.372c.006.063.051.111.116.111.063 0 .11-.048.116-.111l.24-2.372-.24-2.451c-.006-.063-.053-.112-.116-.112m.899-.111c-.073 0-.127.056-.131.126l-.2 2.563.2 2.428c.004.072.058.126.131.126.072 0 .127-.054.132-.126l.226-2.428-.226-2.563c-.005-.072-.06-.126-.132-.126m.899-.073c-.08 0-.142.063-.147.14l-.186 2.636.186 2.465c.005.079.067.14.147.14.079 0 .14-.061.147-.14l.209-2.465-.209-2.636c-.007-.079-.068-.14-.147-.14m.901.001c-.088 0-.156.07-.162.154l-.173 2.635.173 2.49c.006.087.074.154.162.154.086 0 .155-.067.16-.154l.196-2.49-.196-2.635c-.005-.087-.074-.154-.16-.154m.899-.209c-.096 0-.17.078-.175.168l-.16 2.844.16 2.512c.005.095.079.168.175.168.094 0 .17-.073.175-.168l.182-2.512-.182-2.844c-.005-.095-.081-.168-.175-.168m.9-.098c-.104 0-.184.084-.189.182l-.147 2.942.147 2.531c.005.1.085.182.189.182s.184-.082.19-.182l.166-2.531-.166-2.942c-.006-.1-.086-.182-.19-.182m.899-.072c-.112 0-.198.091-.203.196l-.133 3.014.133 2.545c.005.108.091.196.203.196.11 0 .197-.088.202-.196l.151-2.545-.151-3.014c-.005-.108-.092-.196-.202-.196m.9.072c-.12 0-.213.098-.217.21l-.12 2.942.12 2.553c.004.116.097.21.217.21.118 0 .213-.094.217-.21l.135-2.553-.135-2.942c-.004-.116-.099-.21-.217-.21m3.19-.535c-.26 0-.51.032-.75.094-.15-1.705-1.59-3.03-3.35-3.03-.413 0-.813.072-1.186.202-.14.049-.187.1-.19.196v6.069c.003.1.08.18.18.19h5.296c1.324 0 2.398-1.074 2.398-2.398 0-1.324-1.074-2.323-2.398-2.323"/></svg>
  ),
  youtube: (
    <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>
  ),
  instagram: (
    <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z"/></svg>
  ),
  twitter: (
    <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
  ),
  tiktok: (
    <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22"><path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/></svg>
  ),
  facebook: (
    <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
  ),
  bandcamp: (
    <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22"><path d="M0 18.75l7.437-13.5H24l-7.438 13.5z"/></svg>
  ),
  beatport: (
    <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22"><circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" strokeWidth="2"/><path d="M8 8l8 4-8 4z"/></svg>
  ),
  globe: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="22" height="22"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>
  ),
  calendar: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="22" height="22"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
  ),
  link: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="22" height="22"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg>
  ),
};

export const getIcon = (iconKey) => ICON_MAP[iconKey] || ICON_MAP.link;

const ArtistLinksPage = () => {
  const { slug } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const res = await fetch(`${API_URL}/api/links/${slug}`);
        if (!res.ok) {
          setError(res.status === 404 ? 'Artist not found' : 'Failed to load');
          return;
        }
        setData(await res.json());
      } catch (e) {
        setError('Failed to load');
      } finally {
        setLoading(false);
      }
    };
    fetchLinks();
  }, [slug]);

  // SEO meta tags (must be before early returns)
  useSEO({
    title: data?.artist_name ? `${data.artist_name} - Links` : 'Links',
    description: data ? `Find ${data.artist_name} on all platforms. ${data.genre || 'Electronic Music'} artist on Anyone Music Records.` : '',
    image: data?.profile_image || '',
    type: 'profile'
  });

  if (loading) {
    return (
      <div className="linktree-page">
        <div className="linktree-loading">
          <div className="pulse-ring" />
        </div>
      </div>
    );
  }

  if (error || !data) {
    return (
      <div className="linktree-page">
        <div className="linktree-error">
          <h2>{error || 'Something went wrong'}</h2>
          <a href="/" className="back-link">Back to AMR</a>
        </div>
      </div>
    );
  }

  const { artist_name, genre, profile_image, links } = data;
  const hasMusic = links.music?.length > 0;
  const hasSocial = links.social?.length > 0;
  const hasShows = links.shows?.length > 0;
  const hasCustom = links.custom?.length > 0;
  const hasAny = hasMusic || hasSocial || hasShows || hasCustom;

  const formatShowDate = (dateStr) => {
    try {
      const d = new Date(dateStr + 'T00:00:00');
      return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    } catch { return ''; }
  };

  return (
    <div className="linktree-page" data-testid="artist-links-page">
      <div className="linktree-container">
        {/* Artist Header */}
        <header className="linktree-header">
          <div className="artist-avatar">
            {profile_image ? (
              <img src={getFileUrl(profile_image)} alt={artist_name} />
            ) : (
              <div className="avatar-placeholder">{artist_name?.charAt(0)}</div>
            )}
          </div>
          <h1 className="artist-name">{artist_name}</h1>
          {genre && <p className="artist-genre">{genre}</p>}
        </header>

        {/* Links */}
        {hasAny ? (
          <div className="linktree-sections">
            {hasShows && (
              <section className="link-section" data-testid="shows-section">
                <h2 className="section-label">Upcoming Shows</h2>
                {links.shows.map((link, i) => (
                  <a
                    key={`show-${i}`}
                    href={link.url || '#'}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="link-card show-card"
                    data-testid={`show-link-${i}`}
                  >
                    <span className="link-icon">{getIcon(link.icon)}</span>
                    <div className="link-info">
                      <span className="link-title">{link.title}</span>
                      {link.subtitle && <span className="link-subtitle">{link.subtitle}</span>}
                    </div>
                    {link.date && <span className="show-date">{formatShowDate(link.date)}</span>}
                  </a>
                ))}
              </section>
            )}

            {hasMusic && (
              <section className="link-section" data-testid="music-section">
                <h2 className="section-label">Music</h2>
                {links.music.map((link, i) => (
                  <a
                    key={`music-${i}`}
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="link-card"
                    data-testid={`music-link-${i}`}
                  >
                    <span className="link-icon">{getIcon(link.icon)}</span>
                    <span className="link-title">{link.title}</span>
                    <span className="link-arrow">&rsaquo;</span>
                  </a>
                ))}
              </section>
            )}

            {hasSocial && (
              <section className="link-section" data-testid="social-section">
                <h2 className="section-label">Social</h2>
                {links.social.map((link, i) => (
                  <a
                    key={`social-${i}`}
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="link-card"
                    data-testid={`social-link-${i}`}
                  >
                    <span className="link-icon">{getIcon(link.icon)}</span>
                    <span className="link-title">{link.title}</span>
                    <span className="link-arrow">&rsaquo;</span>
                  </a>
                ))}
              </section>
            )}

            {hasCustom && (
              <section className="link-section" data-testid="custom-section">
                {links.custom.map((link, i) => (
                  <a
                    key={`custom-${i}`}
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="link-card"
                    data-testid={`custom-link-${i}`}
                  >
                    <span className="link-icon">{getIcon(link.icon || 'link')}</span>
                    <span className="link-title">{link.title}</span>
                    <span className="link-arrow">&rsaquo;</span>
                  </a>
                ))}
              </section>
            )}
          </div>
        ) : (
          <div className="linktree-empty">
            <p>No links yet</p>
          </div>
        )}

        {/* AMR Branding */}
        <footer className="linktree-footer" data-testid="amr-footer">
          <a href="https://anyonemusicrecords.com" target="_blank" rel="noopener noreferrer" className="amr-brand">
            <span className="amr-logo">AMR</span>
            <span className="amr-text">Anyone Music Records</span>
          </a>
        </footer>
      </div>
    </div>
  );
};

export default ArtistLinksPage;
